import { axiosInstance } from "@/configs/axiosConfig";

export const getEsgSufficiency = (encryptedDuns: string) => {
  return axiosInstance.get("esg", {
    params: {
      duns: encryptedDuns,
    },
  });
};